async function devtricker_ajax_upsert_postage(post_id, title, content, lang) {

    try {

        const form = new FormData();

        form.append('action', 'devtricker_action_post_upsert_postage_ajax');
        form.append('post_id', post_id);
        form.append('post_title', title);
        form.append('post_content', content);
        form.append('lang', lang || 'und');

        form.append('nonce', await devtricker_process_getDevtrickerNonce());

        const response = await fetch('/wp-admin/admin-ajax.php', {
            method: 'POST',
            credentials: 'same-origin',
            body: form
        });

        if (response.status == 200) {
            const result = await response.json();

            if (!result.success) {
                throw new Error(result.data.message);
            }

            devtricker_log(null, devtricker_log_level.INFO, `Post created/updated`);
            return result;
        }

        throw new Error("Failed to create post. Try again later.");

    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR);
        throw error;
    }
}

async function devtricker_ajax_update_postage_status(post_id, post_status) {

    try {
        const form = new FormData();

        form.append('action', 'devtricker_action_devtricker_update_post_status_ajax');
        form.append('post_id', post_id);
        form.append('post_status', post_status);
        form.append('nonce', await devtricker_process_getDevtrickerNonce());

        const response = await fetch('/wp-admin/admin-ajax.php', {
            method: 'POST',
            credentials: 'same-origin',
            body: form
        });

        if (response.status == 200) {
            const result = await response.json();
            devtricker_log(null, devtricker_log_level.INFO, `Post status updated`);
            return result;
        }

        throw new Error("Failed to publish post. Try again later. ");

    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR);
        throw error;
    }
}
